
<div class="footer">
    <div class="container">
        <div class="line"></div>
    <div class="row">
    <div class="col-md-4">
        <div class="logo"><img src="../../../assets/Path 12528.png"></div>
        <p>We are always keen to satisfy our partners through <br> successful marketing and highlighting their <br> uniqueness. </p>
    </div>
    <div class="col-md-4">
        <div class="row">
            <div class="col-4"><ul class="list-unstyled"><li>Home</li><li>About</li><li>Services </li></ul></div>
            <div class="col-4"><ul class="list-unstyled"><li>Careers</li><li>blog</li><li>Contact </li></ul></div>
            <div class="col-4"><ul class="list-unstyled"><li>Location : New Cairo</li><li>Phone number : +0200002000
            </li><li>Email : Hello@rush.com</li></ul></div>
    
        
        </div>
    </div>
    
    
    </div>
    <hr>
    <div class="copy-right">
        <div class="row"><div class="col-8">
            <p>All copyrights reserved to Rush 2020 </p>
        </div>
    <div class="col-4"><i class="fa fa-twitter"></i>
        <i class="fa fa-facebook"></i>
        <i class="fa fa-twitter"></i>
        <i class="fa fa-facebook"></i>
       <p> Designed with        Baianat</p>
    
    </div>
    </div>
    </div>
    </div>
    
    </div>